export default {
    ChangePassword: (data) => window.axios.post('change_password', data),
    UpdateProfile: (data) => window.axios.post('update_profile', data),
    getMessages: (data) => window.axios.post('getmessage', data),
    sendMessages: (data) => window.axios.post('sendmessage', data),
    customerDefaultMessage: (data) => window.axios.post('customer_default_message', data),
}